import Preloader from "../Preloader/Preloader";


const RedirectedPage = (props) => {
    const {location, match, history} = props

    const id = match.params.id
    const detailId = match.params.detailId

    const pathArr = location.pathname.split('/').filter(item => item)

    if (pathArr.includes('contract')) {
        history.push(`/lk/contracts/${id}`)
    }

    if (pathArr.includes('booking') && !detailId) {
        history.push(`/lk/booking/${id}`)
    }
    if (pathArr.includes('booking') && detailId) {
        history.push(`/lk/booking/detail/${detailId}`)
    }

    return (<Preloader loading={true}/>)
}


export default RedirectedPage